import { Modal } from "react-bootstrap";

import styles from "./confirmationModal.module.css";

const ConfirmationModal = ({ show, message, onConfirm, onHide }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered>
      <Modal.Header
        className={styles["form-header"]}
        closeButton>
        <Modal.Title className={styles["form-title"]}>Статус входа</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles["form-body"]}>
        <p className={styles["label"]}>{message}</p>
      </Modal.Body>
      <Modal.Footer className={styles["form-footer"]}>
        <div
          className={styles["save-btn"]}
          onClick={() => onConfirm(true)}>
          Подтвердить
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
